exports.en = {
  PLACES_DETAIL: {
    ATM: {
      NUMBER: 'ATM number:',
      SERVICES: {
        TITLE: 'This ATM can help you with:',
        SHOW_MORE: 'Show more'
      },
      OUT_OF_ORDER: 'Out of order',
      EMPLOYEES: 'ATM is available only for employees with access to the building.'
    },
    BRANCH: {
      PRODUCTS: {
        TITLE: 'Our advisors at the branch <strong>will help you with</strong>',
        SHOW_MORE: 'Show more'
      },
      SPECIALISTS: {
        TITLE: 'Specialists',
        SHOW_MORE: 'Show more',
        SHOW_LESS: 'Show less'
      },
      LKC_SPECIALISTS: {
        TITLE: 'Managers',
        SHOW_MORE: 'Show more',
        SHOW_LESS: 'Show less'
      },
      LKC_MANAGER: {
        POSITION: 'LCC Director',
        PROFILE: 'Profile'
      },
      RKC_MANAGER: {
        POSITION: 'RCC Director',
        PROFILE: 'Profile'
      },
      MANAGER: {
        TITLE: '<strong>Branch</strong> Manager',
        POSITION: 'Branch Manager',
        PROFILE: 'Manager Profile'
      },
      CALLBOX: {
        TITLE: '<strong>Do you need advice</strong> before visiting the branch?',
        CHAT: 'Chat'
      },
      ORDER: {
        TITLE: '<strong>Make an appointment on-line</strong> and save time at the branch',
        ORDER_TO: 'Appointment',
        CASH: 'At cash desk',
        DESK: 'With a banker',
        GEORGE: 'With my banker in George',
        QMATIC_URL_CASH: 'appointment/cash',
        QMATIC_URL_DESK: 'appointment/cashless'
      },
      OUT_OF_ORDER: 'Out of order',
      OUTAGE_NEXT_WEEK_1: 'Opening hours will be',
      OUTAGE_NEXT_WEEK_2: 'changed next week.',
      CLOSED_NEXT_WEEK: 'Branch will be closed',
      SHOW: 'Show',
      HIDE: 'Hide'
    },
    NOTES: {
      CASH_WITHDRAW: {
        CASH_LIMIT: 'In order to withdraw',
        CASH_LIMIT_EXCESS1: 'and higher amount, please notify the branch in advance.',
        CASH_LIMIT_EXCESS2: 'The nearest possible date of withdrawal is',
        DB: {
          '2 dny, s výčetkou 3 dny': '2 days, 3 days with a bill of cash',
          '1 týden': '1 week',
          '48 hodin': '48 hours',
          '1 pracovní den': '1 business day',
          '2 pracovní dny': '2 business days',
          '3 pracovní dny': '3 business days',
          '4 pracovní dny': '4 business days',
          '5 pracovních dnů': '5 business days',
          '2 dny předem': '2 days in advance',
          '1 den': '1 day',
          '2 dny': '2 days',
          '3 dny': '3 days',
          '4 dny': '4 days',
          '5 dnů': '5 days'
        },
        REPORT: 'Notify online'
      },
      SHOW_MORE: 'Show more'
    },
    SERVICES: {
      ACTIVATION_CODE: 'Activation Code for George klíč',
      CONTACTLESS_ATM: 'Contactless',
      CONTACTLESS_SYSTEM_PILSEN: 'Topping up transport cards',
      WEEKEND_OFFICE: 'Weekend hours',
      WITHDRAW_ATM: 'ATM for withdrawals',
      DEPOSIT_ATM: 'ATM for deposits',
      TRANSFER_ATM: 'ATM for transfers',
      BAR_CODE_READER_ATM: 'Barcode reader',
      QR_CODE_READER_ATM: 'QR code reader',
      FOR_BLIND_ATM: 'For the visually impaired',
      ATM_ACCESSIBILITY: 'Barrier-free access',
      HEARING_IMPAIR: 'Equipment for the hearing impaired',
      BARRIER_PARTIALY_FREE: 'Partially barrier-free access',
      BARRIER_FREE: 'Barrier-free access',
      ATM: 'ATM in building',
      CASH_DESK: 'With cash desk',
      SELF_SERVICE: 'Self-service zone',
      EQUIPMENT_17: 'Mincomat coin deposit machine',
      EQUIPMENT_13: 'Special application for the hearing-impaired',
      EQUIPMENT_24: 'ATM for deposits at the branch',
      EQUIPMENT_12: 'Dual ATM (deposits and withdrawals)',
      EQUIPMENT_23: 'ATM for withdrawals at the branch',
      EQUIPMENT_11: 'ATM for payments at the branch',
      EQUIPMENT_9: 'Children’s corner',
      EQUIPMENT_7: 'WiFi',
      EQUIPMENT_6: 'Night safe',
      EQUIPMENT_1: 'Safety deposit box',
      EQUIPMENT_20: 'Offers English language',
      EQUIPMENT_16: 'For the visually impaired',
      EQUIPMENT_18: 'Videoconference',
      EXCHANGE: 'Exchange',
      EXCHANGE_TOOLTIP: 'At this branch, we exchange these currencies: ',
      DEPOSIT_TOOLTIP_ONE: 'At this branch, you can deposit or withdraw foreign currencies in cash from your ČS account.',
      DEPOSIT_TOOLTIP_TWO: 'The following currencies are regularly available at the cash desk: %{currencies}.',
      DEPOSIT_TOOLTIP_THREE: 'Other currencies – %{needOrderCurrencies} – need to be arranged in advance.',
      DEPOSIT_TOOLTIP_FOUR: 'Please inform the branch in advance if you wish to withdraw foreign currencies in an amount equivalent to CZK 10 000 or higher. You can use the on-line form to do this.',
      DEPOSITS: 'Foreign Currency Deposits/Withdrawals'
    },
    PRODUCTS: {
      'Akcie, dluhopisy a služby CDCP': 'Shares, Bonds and CDCP Services',
      'Bezpečnostní schránky': 'Safe Deposit Boxes',
      'Dětské a studentské produkty': 'Products for Children and Students',
      'Dětské a studentské produkty (mimo vkladních knížek)': 'Products for Children and Students (excluding passbooks)',
      'Hypotéka Premier': 'Premier Home Loan',
      'Hypotéky': 'Mortgages',
      'Investiční produkty': 'Investment Products',
      'Karty na nákupy': 'Cards for Purchases',
      'Letištní salónky': 'Airport Lounges',
      'Mincomat': 'Mincomat Coin Deposit Machine',
      'Moje zdravé finance': 'My Healthy Finances',
      'Účet Premier': 'Premier Account',
      'Osobní účty': 'Personal Accounts',
      'Penzijní připojištění': 'Supplementary Pension Scheme',
      'Platební karty': 'Payment Cards',
      'Platební karty /Visa Infinit, MC World Elite/': 'Payment Cards (Visa Infinite, MC World Elite)',
      'Podnikatelské termínované vklady': 'Business Term Deposits',
      'Podnikatelské účty': 'Business Accounts',
      'Podnikatelské úvěry': 'Business Loans',
      'Pojistné produkty': 'Insurance Products',
      'Premier benefit club': 'Premier Benefit Club',
      'Půjčky': 'Loans',
      'Směnárenské služby': 'Foreign Exchange Services',
      'Spoření Premier': 'Premier Savings Account',
      'Spořicí a vkladové produkty': 'Savings and Deposit Products',
      'Spořicí a vkladové produkty (mimo vkladních knížek)': 'Savings and Deposit Products (excluding passbooks)',
      'Stavební spoření': 'Building Savings Account',
      'Úvěr Premier': 'Premier Loan',
      'Vklady a výběry cizí měny z účtu': 'Foreign Currency Deposits/Withdrawals',
      'Vklady a výběry hotovosti': 'Cash Deposits and Withdrawals',
      'Vklady a výběry pouze prostřednictvím bankomatu': 'Cash deposit and withdrawal via ATMs only',
      'Vklady a výběry hotovosti pouze prostřednictvím bankomatu': 'Cash deposit and withdrawal via ATMs only',
      'Výběry hotovosti pouze prostřednictvím bankomatu': 'Cash withdrawals Only via ATM',
      'Výběry pouze prostřednictvím bankomatu': 'Cash withdrawals Only via ATM',
      'Životní pojištění': 'Life Insurance',
      'Vklad Z-obalem': 'Cash deposit in sealed packages'
    },
    MAP: {
      SHOW: 'Show on map',
      HIDE: 'Hide map',
      NAVIGATE: 'Navigate'
    },
    BACK_TO_LIST: 'Back to list',
    ROUTE_SEARCH: 'search',
    BACKEND_ERROR: 'We apologise, but the application is momentarily unavailable. Please contact us toll free on 800 207 207.'
  }
}
